// PRODUCTION — live-updates card for a single changed step.
import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import type { CollectDataTemplatePreviewStepEntry } from 'src/interfaces/collectDataTemplatePreview'
import { ChangeChip } from './ChangeChip'
import { CountsRow } from './CountsRow'
import { OutcomeList } from './OutcomeList'
import { humanize } from './previewFormatting'

interface StepCardProps {
  step: CollectDataTemplatePreviewStepEntry
}

const StepCardComponent = ({ step }: StepCardProps) => {
  return (
    <div
      css={tw`flex flex-col gap-2.5 rounded-[10px] border border-shades-200 bg-shades-0 p-3 border-solid`}
    >
      <div css={tw`flex items-start justify-between gap-2`}>
        <div css={tw`flex flex-col gap-0.5`}>
          <Typography variant="subtitle1" css={tw`text-shades-900`}>
            {step.stepLabel}
          </Typography>
          <Typography variant="subtitle2" css={tw`text-shades-500`}>
            {humanize(step.stepType)}
          </Typography>
        </div>
        <div css={tw`flex-shrink-0`}>
          <ChangeChip changeType={step.stepChangeType} />
        </div>
      </div>

      {step.counts && <CountsRow counts={step.counts} />}

      <OutcomeList changes={step.changes} />

      {step.note && (
        <Typography variant="subtitle2" css={tw`text-shades-500`}>
          {step.note}
        </Typography>
      )}
    </div>
  )
}

export const StepCard = memo(StepCardComponent)
